// extracted by css-extract-rspack-plugin
export default {"quote":"content-editor-plugin-quote-Quote-quote-a0397346","icon":"content-editor-plugin-quote-Quote-icon-8bec21df"};